import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksPendingStatusToolbarSection', {
    requestAmBlockedValidationErrorManager: `
        This request cannot be created in QuickBooks Online upon final approval due to the following issue:
        {issues}.{br}Please update the date of the request or update the lock date in {qBooksLink}`,
    requestBlockedValidationErrorUser: `
        This request cannot be created in QuickBooks Online upon final approval due to the following issues:
        {issues}.{br}Please change document date or contact administrator to update lock date in {qBooksLink}`,
    validationErrorTextLockDateInEffect: 'document date cannot be before the lock date, currently set at {lockDate}',
});
